module.exports = __webpack_public_path__ + "static/media/DIAMOND-12-QUEEN.9ea3c74e.svg";